__turbopack_context__.v({
  "calculations": "_76kaNW_calculations",
  "distance": "_76kaNW_distance",
  "form": "_76kaNW_form",
  "form-wrapper": "_76kaNW_form-wrapper",
  "root": "_76kaNW_root",
  "thick": "_76kaNW_thick",
});
